module.exports = __webpack_public_path__ + "img/ubc_logo2.453fa81e.png";